import React, { useEffect, useState } from 'react';

import { zl, isNumber } from '../../../../functions/utilities';
import { date_to_mm_rrrr, mm_rrrr_to_date, mm_rrrr_to_miesiac, pierwszyDzienMiesiaca, strefa} from '../../../../functions/dataFormat';

const ZbiorowyKomornikTableCzynsze = (props) => {

    const {czynsze, sumaCzynszeTenRok, stawkiInd, saldoStare} = props;

    const czynsze_rok = czynsze?.filter( c => c?.msc.slice(-4) == new Date().getFullYear());

    const czynsze_sort = [];


    const [sumaRazem, setSumaRazem] = useState(0);
    
    useEffect( () => {
        let temp = 0;
        temp += sumaCzynszeTenRok;
        let suma_indy = 0;
        temp += suma_indy;

        setSumaRazem(temp)
    },[sumaCzynszeTenRok, stawkiInd, saldoStare]);

    let indeks = saldoStare !== 0 ? 2 : 1;

    const tab = czynsze_rok?.map( (c, i) => {
         
        const ind_msc = stawkiInd?.filter( s => date_to_mm_rrrr(new Date(s?.msc)) ==  c.msc);

        let indy_suma = 0;

        const indy = ind_msc?.map( (p, i) => {
            indy_suma += p.kwota;
            return (
                <li key={i}>
                    {`${zl(parseFloat(p.kwota))}`}
                    <sup style={{verticalAlign: "super", fontSize: "0.8em"}}>{`${indeks++}`}</sup>
                </li>
        )
        })
        
        const czySaldoStare = new Date(mm_rrrr_to_date(c.msc)).getMonth() == 0 ? (saldoStare * -1) : 0;

        return (
            <tr key={i}>
                <td style={{
                    textAlign: "center",
                    padding: "4px 5px",
                    border: "1px solid black"
                }}>
                    {mm_rrrr_to_miesiac(c.msc)}
                </td>
                <td style={{
                    textAlign: "right",
                    padding: "4px 5px",
                    border: "1px solid black",
                    style: "white-space:nowrap"
                }}>
                    {zl(c.czynsz_na_msc + czySaldoStare + indy_suma)}
                </td>
                <td style={{
                    textAlign: "right",
                    padding: "4px 5px",
                    border: "1px solid black",
                    style: "white-space:nowrap"
                }}>
                    {
                        czySaldoStare !== 0 && (
                            <ul>
                                <li>{`${zl(saldoStare)}`}<sup style={{verticalAlign: "super", fontSize: "0.8em"}}>{` ${1}`}</sup> </li>
                            </ul>
                        )
                    }
                    { 
                        ind_msc?.length > 0 && (
                            <ul>
                                {indy}
                            </ul>
                        )

                    }
                </td>
        
            </tr>
        )
    })

    return (
        <div>
            <table
                style={{
                    border: "1px solid black", 
                    fontSize: "11px",
                    maxWidth: "450px"
                }}
            >
                <thead>
                    <tr>
                        <th
                            style={{
                                border: "1px solid black",
                                padding: "4px 15px"}}
                        >
                            Miesiąc
                        </th>
                        <th
                            style={{
                                border: "1px solid black",
                                padding: "4px 15px"}}
                        >
                            Należność
                        </th>
                        <th
                            style={{
                                border: "1px solid black",
                                padding: "4px 15px"}}
                        >
                            W tym
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {tab}
                </tbody>
                <tfoot>
                    <tr>
                        <td style={{
                            textAlign: "center",
                            padding: "4px 5px",
                            border: "1px solid black"
                        }}>
                            Razem
                        </td>
                        <td style={{
                            textAlign: "right",
                            padding: "4px 5px",
                            border: "1px solid black",
                            style: "white-space:nowrap"
                        }}>
                            {zl(sumaRazem)}
                        </td>
                        <td style={{
                            textAlign: "center",
                            padding: "4px 5px",
                            border: "1px solid black"
                        }}>
                            
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    )
}

export default ZbiorowyKomornikTableCzynsze;